/**
 * Sanitizes error messages by removing explicit mentions of logistics providers (Nimbus, SKart).
 * @param {string} msg - The raw error message
 * @returns {string} The sanitized message
 */
export const sanitizeError = (msg) => {
  if (!msg || typeof msg !== 'string') return msg;

  return msg
    .replace(/nimbuspost/gi, 'Logistics Provider')
    .replace(/nimbus/gi, 'Logistics Provider')
    .replace(/skart logistics/gi, 'Standard Shipping')
    .replace(/skart/gi, 'Standard Shipping')
    .replace(/api key/gi, 'configuration');
};
